import React from 'react';
import clsx from 'clsx';
import styles from '../PrintTasksRow.module.scss';
import { TaskRowViewModel, TaskPrintType } from '../../utils/TaskPrintMapper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBowlFood,
    faSuitcaseMedical,
    faDroplet,
    faToilet,
    faPuzzlePiece,
    IconDefinition
} from '@fortawesome/pro-regular-svg-icons';

const ICONS: Record<TaskPrintType, IconDefinition> = {
    feeding: faBowlFood,
    medication: faSuitcaseMedical,
    hydration: faDroplet,
    relief: faToilet,
    addon: faPuzzlePiece
};

const ICON_CLASS: Record<TaskPrintType, string> = {
    feeding: styles.iconFeeding,
    medication: styles.iconMedication,
    hydration: styles.iconHydration,
    relief: styles.iconRelief,
    addon: styles.iconAddon
};

const taskCell = (type: TaskPrintType, body: React.ReactNode, timeLabel?: string) => {
    const icon = ICONS[type];
    return (
        <div className={styles.taskCell}>
            {icon && (
                <div className={clsx(styles.taskIcon, ICON_CLASS[type])}>
                    <FontAwesomeIcon icon={icon} />
                </div>
            )}
            <div className={styles.taskTexts}>
                {body}
                {timeLabel && <div className={styles.taskTime}>{timeLabel}</div>}
            </div>
        </div>
    );
};

export const TasksRenderer: Record<TaskPrintType, (row: TaskRowViewModel) => JSX.Element> = {
    feeding: row => {
        const subtitleParts = row.taskSubtitle ? row.taskSubtitle.split(',').map(p => p.trim()) : [];

        return taskCell(
            'feeding',
            <>
                <div className={styles.taskTitle}>{row.taskTitle}</div>
                {subtitleParts[1] && <div className={styles.taskExtra}>{subtitleParts[1]}</div>}
                {subtitleParts[0] && <div className={styles.taskSubtitle}>{subtitleParts[0]}</div>}
            </>,
            row.timeLabel
        );
    },

    medication: row =>
        taskCell(
            'medication',
            <>
                <div className={styles.taskTitle}>{row.taskTitle}</div>
                {row.taskSubtitle && <div className={styles.taskSubtitle}>{row.taskSubtitle}</div>}
            </>,
            row.timeLabel
        ),

    hydration: row => taskCell('hydration', <div className={styles.taskTitle}>{row.taskTitle}</div>, row.timeLabel),

    relief: row => taskCell('relief', <div className={styles.taskTitle}>{row.taskTitle}</div>, row.timeLabel),

    addon: row => taskCell('addon', <div className={styles.taskTitle}>{row.taskTitle}</div>, row.timeLabel)
};

export default TasksRenderer;
